import dayjs from "../../../../../../../configs/dayjs";
import { ReactNode, useMemo } from "react";
import { DATE_FORMAT } from "../../../../../../../lib/constants";

export const useSetLastUpdated = (data: any) => {
  const lastUpdated: ReactNode = useMemo(
    () =>
      data ? (
        <p className="my-0 text-md title mr-8">
          Last Updated:&nbsp;
          {dayjs(data.lastModifiedDateTime).format(DATE_FORMAT)}
        </p>
      ) : (
        <div />
      ),
    [data]
  );

  return { lastUpdated };
};
